import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M19.5 12a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-8.25-4.836a.75.75 0 0 1 1.5 0v4.443l3.375 2.337a.75.75 0 1 1-.854 1.234l-3.698-2.56A.75.75 0 0 1 11.25 12zM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
    }, null, -1)
  ]))]))
}
export default { render: render }